import { ITabDef } from '../../../../../helpers/tabErrorUtils'

export type ISeriesFormTabDef = ITabDef

/**
 * Canonical tab definitions in display order. The modal hides `editions`/`tickets`/
 * `establishments` entirely in `sourceEvent` mode (mirrors the old `{!sourceEvent && (...)}` block) and
 * `location` when the series format doesn't need an address (see `needsLocation`).
 */
export const SERIES_TAB_DEFS: ISeriesFormTabDef[] = [
  {
    key: 'general',
    label: 'Geral',
    fields: ['name', 'slug', 'course_ids', 'format', 'types', 'thumb', 'thumb_wide', 'video', 'remove_video']
  },
  { key: 'content', label: 'Conteúdo', fields: ['copy', 'target_audience', 'topics', 'use_term', 'term'] },
  {
    key: 'engagement',
    label: 'Depoimento & Dúvidas',
    fields: ['testimonial_title', 'testimonial_videos', 'testimonial_existing', 'use_testimonial', 'use_help_form']
  },
  { key: 'faq', label: 'FAQ', fields: ['faqs'] },
  { key: 'marketing', label: 'Marketing', fields: ['active_campaign_lead_lists', 'active_campaign_buyer_lists'] },
  { key: 'editions', label: 'Edições', fields: ['editions'] },
  { key: 'tickets', label: 'Ingressos', fields: ['ticket_templates', 'min_installment_value'] },
  // ABRA-317 — antes de "Local", que tem de continuar a última.
  { key: 'establishments', label: 'Produtos e Serviços', fields: ['establishment_templates'] },
  {
    key: 'location',
    label: 'Local',
    fields: [
      'zipcode',
      'street',
      'number',
      'complement',
      'neighborhood',
      'city',
      'state',
      'latitude',
      'longitude',
      'place_id',
      'place_name'
    ]
  }
]

export { countErrorsPerTab, firstTabWithErrors, unmappedErrorMessages } from '../../../../../helpers/tabErrorUtils'
